module.exports = __webpack_public_path__ + "img/coding.2d1fd4e4.png";